import { useEffect, useState } from 'react';
import { isWebPSupported } from '@rendering/plasma';
import { WebGlSupported } from '@rendering/vortex-react';
import { load } from '@rendering/flash';
import { memoizePromiseFn } from '../utils/memoizePromiseFn';
function getSearchParam(params, target) {
  var _a;
  return (_a = params.get(target)) !== null && _a !== void 0 ? _a : params.get(target.toLowerCase());
}
function parseScene(url) {
  var _a;
  const params = new URLSearchParams(new URL(url).search);
  return (_a = getSearchParam(params, 'scene')) !== null && _a !== void 0 ? _a : url;
}
export const memoizedLoadCompiledScene = memoizePromiseFn(async _ref => {
  let {
    sceneUrl
  } = _ref;
  const webPSupported = await isWebPSupported();
  const imageFormat = webPSupported ? 'webp' : 'png';
  return await load({
    sceneUrl,
    settings: {
      environment: 'prod',
      imageFormat,
      imageQuality: 85
    }
  });
});
export const useCompiledScene = _ref2 => {
  let {
    scene
  } = _ref2;
  const [compiledSceneState, setCompiledSceneState] = useState();
  useEffect(() => {
    let ignore = false;
    const sceneUrl = parseScene(scene);
    if (!WebGlSupported()) {
      setCompiledSceneState({
        source: scene,
        needsServerFallback: true
      });
      return;
    }
    memoizedLoadCompiledScene({
      sceneUrl
    }).then(result => {
      if (!ignore) {
        setCompiledSceneState({
          source: scene,
          compiledScene: result,
          needsServerFallback: false
        });
      }
    }).catch(() => {
      if (!ignore) {
        setCompiledSceneState({
          source: scene,
          needsServerFallback: true
        });
      }
    });
    return () => {
      ignore = true;
    };
  }, [scene]);
  if (scene === (compiledSceneState === null || compiledSceneState === void 0 ? void 0 : compiledSceneState.source)) {
    return {
      compiledScene: compiledSceneState.compiledScene,
      needsServerFallback: compiledSceneState.needsServerFallback
    };
  }
  return {
    compiledScene: undefined,
    needsServerFallback: false
  };
};